import { render, staticRenderFns } from "./SimilarQuestions.vue?vue&type=template&id=2537484f&scoped=true&"
import script from "./SimilarQuestions.vue?vue&type=script&lang=js&"
export * from "./SimilarQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SimilarQuestions.vue?vue&type=style&index=0&id=2537484f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537484f",
  null
  
)

export default component.exports